import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  ingestThoughtsApiCrud,
  type IngestThoughtsResponse,
  type IngestThoughtsRequest,
} from "@/generated/fastapi";

export async function ingestThoughts(
  accessToken: string | null | undefined,
  request: IngestThoughtsRequest,
): Promise<IngestThoughtsResponse> {
  const response = await ingestThoughtsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to ingest thoughts (${response.status})`);
  }

  if (
    response.data.status !== "success" &&
    response.data.status !== "pending"
  ) {
    throw new Error(response.data.message || "Failed to ingest thoughts");
  }

  return response.data;
}
